import React from 'react'
import NumberFormat from "react-number-format";
import PaymentStatus from "./PaymentStatus";
import { getShipmentV4 } from '../../../APIs/Helpers';

const ChargesV1 = ({ shipment, paymentStatusHide, shipmentV4 }) => {
    if (!shipment) { return null }
    if (!shipmentV4) {
        return (
            <div>
                <span className='cardBodyRow1'>Charges:</span>
                <div>
                    <div className="spinner-grow spinner-grow-sm" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
                <hr />
            </div>
        )
    }
    if (shipment && shipmentV4) {
        const hasAccessorials = shipmentV4?.details?.accessorialDetails?.length > 0
        const hasBilledCost = !!shipment.charges.billedCost
        const hasEstCost = shipment?.chargesList?.some(c => c.type === "estimatedCost" && c.total)
        const hasAnyCharges = hasAccessorials || hasBilledCost || hasEstCost

        return (
            <div>
                <span className='cardBodyRow1'>Charges:</span>
                {!hasAnyCharges && <div><small className="text-muted">No charges information</small></div>}
                {hasAccessorials ?

                    <div>
                        Accessorials:
                        <ul>
                            {shipmentV4.details.accessorialDetails.map((accessorial) => {
                                return (
                                    <li key={accessorial.id}>
                                        {accessorial.formDisplay}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    : null}
                <div className={`${paymentStatusHide}`}>
                    Payment Status: <PaymentStatus shipment={shipment} />
                </div>
                {hasBilledCost && (
                    <div>
                        Billed:{" "}
                        <NumberFormat
                            value={shipment.charges.billedCost}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                        />
                    </div>
                )}

                {hasEstCost && (
                    <div>
                        Est. Cost:{" "}
                        {shipment.chargesList.map((charge, index) => {
                            if (charge.type === "estimatedCost") {
                                return (
                                    <NumberFormat
                                        key={index}
                                        value={charge.total}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                    />
                                )
                            } else {
                                return null
                            }
                        })}
                    </div>
                )}
                <hr /> 
            </div>
        )
    }
}

export default ChargesV1
